import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import { getPageProps } from "@services/initial-calls";
import { useDomainContext } from "@hooks/useDomainContext";
import dynamic from "next/dynamic";
import AtmMachinePricesWrapper from "@components/layouts/atmmachinepricesWrapper";
import MainBanner from "@components/atmmachineprices/mainBanner";

const FAQ = dynamic(() => import("@components/atmmachineprices/faq"));
const OffersList = dynamic(() => import("@components/shared/offersList"));

export default function AtmMachinePricesHome(): ReactElement {
    const { domain } = useDomainContext();

    return (
        <AtmMachinePricesWrapper>
            <MainBanner />
            <section style={{ padding: "0 15px" }}>
                <OffersList offers={domain?.defaultOffers} />
            </section>
            <FAQ />
        </AtmMachinePricesWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home");
};
